import { useEffect } from 'react';

export interface UseDiscussionAnchorFromUrlOptions {
  discussionAnchorId: string | null;
  onAnchorFromUrl: (anchorId: string) => void;
  onOpenDiscussion?: () => void;
}

/** Applies ?discussionAnchor= from email deep links once per navigation. */
export function useDiscussionAnchorFromUrl({
  discussionAnchorId,
  onAnchorFromUrl,
  onOpenDiscussion
}: UseDiscussionAnchorFromUrlOptions): void {
  useEffect(() => {
    if (!discussionAnchorId) return;
    onOpenDiscussion?.();
    onAnchorFromUrl(discussionAnchorId);
  }, [discussionAnchorId, onAnchorFromUrl, onOpenDiscussion]);
}
